import Q from 'q';

import productOwnershipsApi from 'bundles/product/api/productOwnerships';

export default function (userProductItem: string, options?: Record<string, any>) {
  return Q(productOwnershipsApi.get(userProductItem, options || {}));
}
